export default "__VITE_ASSET__C1qNtRg6__"